/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

import debugMessages from './messages';

const styles = cssMap({
	container: {
		paddingBlock: token('space.050'),
	},
	label: {
		font: token('font.body.small'),
		color: token('color.text.subtlest'),
		fontWeight: token('font.weight.medium'),
	},
});

interface DebugToggleProps {
	/** Whether debug mode is currently enabled */
	isEnabled: boolean;
	/** Toggle callback */
	onChange: (enabled: boolean) => void;
}

/**
 * A small toggle control to enable/disable debug mode on the Insights Feed.
 * When enabled, the next fetch will include `debug_info: true`.
 */
export const DebugToggle = ({ isEnabled, onChange }: DebugToggleProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Flex alignItems="center" gap="space.050" xcss={styles.container}>
			<Box as="span" xcss={styles.label}>
				{formatMessage(debugMessages.debugLabel)}
			</Box>
			<Toggle
				id="insights-debug-toggle"
				isChecked={isEnabled}
				onChange={(e) => onChange(e.currentTarget.checked)}
				label={formatMessage(debugMessages.toggleDebugMode)}
			/>
		</Flex>
	);
};
